import {
  FaHeartbeat,
  FaProjectDiagram,
  FaCodeBranch,
} from "@onemind-services-llc/react-icons-ng/fa";
import { MdApi } from "@onemind-services-llc/react-icons-ng/md";
import HeroBg from "public/marketplace-apps/hero/Hero-section-postgresql.png";

export const PostgreHA_CONSTANTS = {
  HERO: {
    title: "OneMind Services — PostgreSQL High Availability (One-Click Application) ",
    desc: "Deploy a high-availability PostgreSQL cluster setup with synchronous replication, automated failover, and load balancing.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "PostgreSQL-HA is a production-grade high availability setup for PostgreSQL that ensures fault tolerance, automated failover, and minimal downtime. It typically uses a combination of Patroni, etcd, and HAProxy to maintain cluster health and seamless failover between primary and standby nodes. ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure PostgreSQL-HA cluster in minutes—no need to manually assemble failover or monitoring components. ",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data center regions to keep latency low and performance high. ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes Patroni, etcd, HAProxy, PostgreSQL, and default replication settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "postgres",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    connection: {
      text: "Connect using:  ",
      command: "-U postgres -h <YOUR_INSTANCE_IP> -p 5432 ",
    },
    installation: {
      heading: "Installation Location -",
      text: "Main configuration files are in: ",
      location: [
        "/etc/patroni/ (Patroni) ",
        "/etc/postgresql/ (PostgreSQL) ",
        "/etc/haproxy/ (HAProxy) ",
      ],
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses:",
      list: [
        "5432 (PostgreSQL via HAProxy)  ",
        "2379 (etcd) ",
        "8008 (Patroni REST API) ",
      ],
    },
    note: "Note : Check /etc/patroni/config.yml and /etc/postgresql/ for cluster and database-specific configurations. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaHeartbeat,
        title: "Automated Failover",
        text: "Patroni and etcd enable automatic election and promotion of a new primary if the current one fails.",
      },
      {
        icon: FaProjectDiagram,
        title: "Cluster State Monitoring",
        text: "HAProxy routes traffic to the current primary node, ensuring continuous availability.",
      },
      {
        icon: FaCodeBranch,
        title: "Synchronous Replication",
        text: "Supports synchronous and asynchronous streaming replication.",
      },
      {
        icon: MdApi,
        title: "RESTful API for Management",
        text: "Patroni exposes a lightweight REST API for monitoring and administrative control.",
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or native PostgreSQL tools for base backups and WAL archiving. ",
      },
      {
        label: "Security Out of the Box",
        text: "Includes TLS support, authentication rules, and restricted access to control plane components. ",
      },
      {
        label: "Scalable Architecture",
        text: "Add standby nodes as needed; horizontal scaling supported for read workloads.  ",
      },
    ],
  },
  SUPPORT: {
    docsText: "Patroni Github Repo",
    docsLink: "https://github.com/patroni/patroni",
    docsText2: "PostgreSQL Docs",
    docsLink2: "https://www.postgresql.org/docs/",
  },
};
